import React, { useState } from "react";
import { IoTrash } from "react-icons/io5";
import { CustomProperty } from "../types/types";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";

interface CustomPropertiesModalProps {
  isOpen: boolean;
  inputOnly: boolean;
  onClose: () => void;
  onSave: (customProperties: CustomProperty[]) => void;
  initialProperties: CustomProperty[];
}

const CustomPropertiesModal: React.FC<CustomPropertiesModalProps> = ({
  isOpen,
  inputOnly,
  onClose,
  onSave,
  initialProperties,
}) => {
  const [customProperties, setCustomProperties] =
    useState<CustomProperty[]>(initialProperties);

  React.useEffect(() => {
    setCustomProperties(initialProperties);
  }, [initialProperties]);

  const handleAddProperty = () => {
    setCustomProperties([
      ...customProperties,
      { name: "", type: "string", value: "", visible: true },
    ]);
  };

  const handlePropertyChange = (
    index: number,
    field: keyof CustomProperty,
    value: any,
    visible?: boolean
  ) => {
    const updatedProperties = [...customProperties];
    if (field in updatedProperties[index]) {
      (updatedProperties[index][field] as typeof value) = value;
    }
    if (visible !== undefined) {
      updatedProperties[index].visible = visible;
    }
    setCustomProperties(updatedProperties);
  };

  const handleDeleteProperty = (index: number) => {
    const updatedProperties = customProperties.filter((_, i) => i !== index);
    setCustomProperties(updatedProperties);
  };

  const handleSave = () => {
    onSave(customProperties);
    onClose();
  };

  return (
    <Dialog
      header="Properties"
      visible={isOpen}
      style={{ width: "800px" }}
      onHide={onClose}
      footer={
        <div>
          <Button
            label="Close"
            icon="pi pi-times"
            onClick={onClose}
            className="p-button-text"
          />
          <Button
            label="Save"
            icon="pi pi-check"
            onClick={handleSave}
            autoFocus
          />
        </div>
      }
    >
      <div className="modal-body">
        <table className="custom-properties-table" style={{ width: "99.9%" }}>
          <thead>
            <tr>
              <th>Name</th>
              <th>Type</th>
              <th>Value</th>
              <th>Show</th>
              {!inputOnly && <th></th>}
            </tr>
          </thead>
          <tbody>
            {customProperties.map((property, index) => (
              <tr key={index}>
                <td>
                  <input
                    disabled={inputOnly}
                    type="text"
                    value={property.name}
                    onChange={(e) =>
                      handlePropertyChange(index, "name", e.target.value)
                    }
                  />
                </td>
                <td>
                  <select
                    disabled={inputOnly}
                    value={property.type}
                    onChange={(e) =>
                      handlePropertyChange(index, "type", e.target.value)
                    }
                  >
                    <option value="string">String</option>
                    <option value="number">Number</option>
                    <option value="currency">Currency</option>
                    <option value="boolean">Boolean</option>
                    <option value="date">Date</option>
                    <option value="calculated">Calculated</option>
                  </select>
                </td>
                <td>
                  {property.type === "string" && (
                    <input
                      type="text"
                      value={property.value}
                      onChange={(e) =>
                        handlePropertyChange(index, "value", e.target.value)
                      }
                    />
                  )}
                  {property.type === "number" && (
                    <input
                      type="number"
                      value={property.value}
                      onChange={(e) =>
                        handlePropertyChange(index, "value", e.target.value)
                      }
                    />
                  )}
                  {property.type === "currency" && (
                    <input
                      type="number"
                      value={property.value}
                      onChange={(e) =>
                        handlePropertyChange(index, "value", e.target.value)
                      }
                    />
                  )}
                  {property.type === "boolean" && (
                    <input
                      type="checkbox"
                      checked={property.value}
                      onChange={(e) =>
                        handlePropertyChange(index, "value", e.target.checked)
                      }
                    />
                  )}
                  {property.type === "date" && (
                    <input
                      type="date"
                      value={property.value}
                      onChange={(e) =>
                        handlePropertyChange(index, "value", e.target.value)
                      }
                    />
                  )}
                  {property.type === "calculated" && (
                    <input
                      disabled={inputOnly}
                      type="text"
                      value={property.value}
                      onChange={(e) =>
                        handlePropertyChange(index, "value", e.target.value)
                      }
                    />
                  )}
                  {/* {property.type === "list" &&
                      (inputOnly ? (
                        <select
                          value={property.value.split(/[,;]/).map((v) => v.trim())}
                          onChange={(e) =>
                          handlePropertyChange(
                            index,
                            "value",
                            Array.from(e.target.selectedOptions, (option) => option.value).join("; ")
                          )
                          }
                        >
                          {property.value
                          .split(/[,;]/)
                          .map((option: string, idx: number) => (
                            <option key={idx} value={option.trim()}>
                            {option.trim()}
                            </option>
                          ))}
                        </select>
                      ) : (
                        <input
                          disabled={inputOnly}
                          type="text"
                          value={property.value}
                          onChange={(e) =>
                            handlePropertyChange(index, "value", e.target.value)
                          }
                        />
                      ))} */}
                </td>
                <td style={{ textAlign: "center", width: 25 }}>
                  <input
                    disabled={inputOnly}
                    type="checkbox"
                    defaultChecked={true}
                    checked={property.visible}
                    onChange={(e) =>
                      handlePropertyChange(
                        index,
                        "visible",
                        property.visible,
                        e.target.checked
                      )
                    }
                  />
                </td>
                {!inputOnly && (
                  <td style={{ textAlign: "center", width: 25 }}>
                    <IoTrash
                      size={20}
                      color="#3c5973"
                      onClick={() => handleDeleteProperty(index)}
                      style={{ cursor: "pointer" }}
                    />
                  </td>
                )}
              </tr>
            ))}
            {!inputOnly && (
              <tr>
                <td colSpan={4}>
                  <button onClick={handleAddProperty}>Add Property</button>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </Dialog>
  );
};

export default CustomPropertiesModal;
